import { useEffect } from "react";

/**
 * Locks the viewport width while this component is mounted
 * and restores the previous meta content on unmount.
 */
export default function useFixedViewportWidth(width = 1310) {
  useEffect(() => {
    // find or create the meta tag
    let meta = document.querySelector('meta[name="viewport"]');
    const prev = meta?.getAttribute('content');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'viewport';
      document.head.appendChild(meta);
    }

    // lock to desktop width
    meta.setAttribute(
      'content',
      `width=${width}, initial-scale=1, user-scalable=yes, viewport-fit=cover`
    );

    // restore on unmount
    return () => {
      if (prev) {
        meta.setAttribute('content', prev);
      } else if (meta?.parentNode) {
        meta.parentNode.removeChild(meta);
      }
    };
  }, [width]);
}
